import React, { useState } from 'react'
import { FaBolt } from 'react-icons/fa'
import '../Tools.css'

const OhmsLawCalculator = () => {
    const [voltage, setVoltage] = useState('')
    const [current, setCurrent] = useState('')
    const [resistance, setResistance] = useState('')
    const [power, setPower] = useState('')

    const calculateOhmsLaw = (known1, known2, type) => {
        const v = parseFloat(voltage)
        const i = parseFloat(current)
        const r = parseFloat(resistance)
        const p = parseFloat(power)

        if (type === 'resistance' && !isNaN(v) && !isNaN(i) && i !== 0) {
            setResistance((v / i).toFixed(4))
            setPower((v * i).toFixed(4))
        } else if (type === 'current' && !isNaN(v) && !isNaN(r) && r !== 0) {
            setCurrent((v / r).toFixed(4))
            setPower((v * v / r).toFixed(4))
        } else if (type === 'voltage' && !isNaN(i) && !isNaN(r)) {
            setVoltage((i * r).toFixed(4))
            setPower((i * i * r).toFixed(4))
        } else if (type === 'fromPower') {
            if (!isNaN(p) && !isNaN(v) && v !== 0) {
                setCurrent((p / v).toFixed(4))
                setResistance((v * v / p).toFixed(4))
            } else if (!isNaN(p) && !isNaN(i) && i !== 0) {
                setVoltage((p / i).toFixed(4))
                setResistance((p / (i * i)).toFixed(4))
            } else if (!isNaN(p) && !isNaN(r) && r !== 0) {
                setVoltage(Math.sqrt(p * r).toFixed(4))
                setCurrent(Math.sqrt(p / r).toFixed(4))
            }
        }
    }

    const clearAll = () => {
        setVoltage('')
        setCurrent('')
        setResistance('')
        setPower('')
    }

    return (
        <div className="tool-calculator">
            <h3><FaBolt /> Ohm's Law Calculator</h3>
            <p className="tool-description">Enter any two values to calculate the remaining values using Ohm's Law (V = I &times; R).</p>

            <div className="ohms-law-grid">
                <div className="input-group">
                    <label>Voltage (V)</label>
                    <input
                        type="number"
                        value={voltage}
                        onChange={(e) => setVoltage(e.target.value)}
                        placeholder="Volts"
                    />
                </div>
                <div className="input-group">
                    <label>Current (A)</label>
                    <input
                        type="number"
                        value={current}
                        onChange={(e) => setCurrent(e.target.value)}
                        placeholder="Amperes"
                    />
                </div>
                <div className="input-group">
                    <label>Resistance (&Omega;)</label>
                    <input
                        type="number"
                        value={resistance}
                        onChange={(e) => setResistance(e.target.value)}
                        placeholder="Ohms"
                    />
                </div>
                <div className="input-group">
                    <label>Power (W)</label>
                    <input
                        type="number"
                        value={power}
                        onChange={(e) => setPower(e.target.value)}
                        placeholder="Watts"
                    />
                </div>
            </div>

            <div className="button-group">
                <button onClick={() => calculateOhmsLaw(null, null, 'resistance')} className="calc-btn">Calculate R (from V, I)</button>
                <button onClick={() => calculateOhmsLaw(null, null, 'current')} className="calc-btn">Calculate I (from V, R)</button>
                <button onClick={() => calculateOhmsLaw(null, null, 'voltage')} className="calc-btn">Calculate V (from I, R)</button>
                <button onClick={() => calculateOhmsLaw(null, null, 'fromPower')} className="calc-btn">Calculate from Power</button>
                <button onClick={clearAll} className="calc-btn clear-btn">Clear All</button>
            </div>
        </div>
    )
}

export default OhmsLawCalculator
